import { Component, OnInit } from '@angular/core';
import { StaffImportViewService } from '../../services/staff-import-view.service';
import { StaffImportService } from '../../services/staff-import.service';
@Component({
    selector: 'app-excel-column-panel',
    templateUrl: './excel-column-panel.component.html',
    styleUrls: ['./excel-column-panel.component.scss'],
    standalone: false
})
export class ExcelColumnPanelComponent implements OnInit {

  displayedColumns: string[] = ['name', 'columnName'];    // Name is alphabetic letter, and columnName is name in table camposImportacion
  dataSource: { position: number, name: string, columnName: string}[] = [];
  camposImportacionList: any[]= [];
  selectedCamposImportacionList: any[]= [];

  constructor(
    public staffImportService: StaffImportService,
    public staffImportViewService: StaffImportViewService) { }

  ngOnInit() {
    this.populateExcelColumnList('A1:IV256');
    this.populateDropdown();
    this.staffImportViewService.selectedCamposImportacionList.subscribe((res) => {
      this.selectedCamposImportacionList = res;
      this.populateExcelColumnList('A1:IV256');
    });
  }

  populateDropdown(){
    this.camposImportacionList = ['% Jornada (0-1)', '% Jornada (0-100)', 'Atributo 1', 'Atributo 2', 'Atributo 3', 'Atributo 4',
    'Atributo 5', 'Atributo 6','Atributo 7', 'Atributo 8', 'Atributo 9', 'Atributo 10', 'Atributo 11', 'Atributo 12',
    'DNI', 'Edad', 'Empresa', 'Empresa 2', 'Empresa 3', 'Empresa o Atributo 1', 'Eulen Proyecto', 'F. Antigüedad',
    'F. Fin Contrato', 'F. Nacimiento', 'N. Referencia', 'Plantilla', 'Sexo (H/M)', 'Sexo (M/F)']
  }

  populateExcelColumnList(range: string){
    this.dataSource = [];
    var i,
    rangeNum = range.split(':').map(function(val) {
      if(val){
        var temp =  val.replace(/[0-9]/g, '');
        var num = 0; 
        for (var t = 0; t < temp.length; t++) {
          num = num * 26 + temp.charCodeAt(t) - 0x40;
        }  
         return num - 1;
      }
    }), start = rangeNum[0], end = rangeNum[1] + 1;
    for (i = start; i < end ; i++) {
      var columnNo = 1 + i;
      var columnName = null;
      if(this.selectedCamposImportacionList.length !=0){
        var obj = this.selectedCamposImportacionList.find(x=>x.columna == columnNo);
        if(obj)
          columnName = obj.campo;
      }
      this.dataSource.push({ position: columnNo , name: this.numToAlpha(i), columnName: columnName});      
    }
  }

  numToAlpha(num: number) {
    var alpha = '';  
    for (;num >= 0; num = parseInt((num / 26).toString(), 10) - 1) {
      alpha = String.fromCharCode(num % 26 + 0x41) + alpha;
    }  
    return alpha;
  }

  getselectedColumnsData(){
    return this.dataSource.filter(x=>x.columnName != null);
  }

  clearExcelColumnList(){
    this.selectedCamposImportacionList = [];
    this.populateExcelColumnList('A1:IV256');
  }
  
  clearColumn(data:any){
    data.columnName = null;
  }
}

